





















import { defineComponent } from '@vue/composition-api'

/**
 * SFgo Award ランキングヘッダーセクション
 */
export default defineComponent({
  name: 'AwardRankingHeaderSection',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
})
